import { css } from "styled-components";

interface SomeObject {
  [key: string]: any;
}

const sizes: SomeObject = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 430,
  tabletS: 510,
  tabletM: 648,
  tablet: 768,
  laptop: 1023,
  laptopM: 1280,
  laptopL: 1440,
  desktop: 2560,
};

export const MobileFirst = Object.keys(sizes).reduce(
  (acc: SomeObject, label: string) => {
    acc["mf_" + label.toString()] = (
      literals: TemplateStringsArray,
      ...args: any[]
    ) => css`
      @media (min-width: ${sizes[label]}px) {
        ${css(literals, ...args)};
      }
    `;
    return acc;
  },
  {}
);

export default Object.keys(sizes).reduce((acc: SomeObject, label: string) => {
  acc[label] = (literals: TemplateStringsArray, ...args: any[]) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(literals, ...args)};
    }
  `;
  return acc;
}, {});
